// Specifies header size per level of layout depth.
// Must always be sync with --w-gl-level-1-header-height CSS variables.

export const nativeLayoutHeaderSizes = new Map<number, number>([
  [1, 24],
  [2, 24],
  [3, 24],
]);
